var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Jinwoo Park
 * @contact libfairy720@datasolution.kr
 * @date 2023-09-12
 * @brief SEI 운영관리 - 사용자 관리 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
// recoil
import { useAsync } from "react-async";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, userInfoLoginState } from "../../../../recoil/userState";
// utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { curAdminTreeState } from "../../../../recoil/assessmentState";
import EhpPagination from "../../../common/pagination/EhpPagination";
// datepicker
// datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
// datepocker 언어
import { useNavigate } from "react-router-dom";
import { langId } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
/**
 * @brief EHP 운영 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function UserList(props) {
    // trans, navgate, ref
    const navigate = useNavigate();
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const reload = useRecoilValue(reLoad);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop } = props;
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    // width 1650 Check용
    const [is1650M, setIs1650M] = useState(false);
    useEffect(() => {
        // resize handler
        // Mobile 체크
        function handleResize() {
            if (window.innerWidth <= 1650) {
                setIs1650M(true);
            }
            else {
                setIs1650M(false);
            }
            if (window.innerWidth <= 940) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 940) {
            setMobile(true);
        }
        if (window.innerWidth <= 1650) {
            setIs1650M(true);
        }
    }), 100);
    // useState
    const [userList, setUserList] = useState([]);
    const [engineerInfo, setEngineerInfo] = useState(null);
    const [chnanTree, setChnanTree] = useState(null);
    const [selecteds, setSelecteds] = useState(0);
    useEffect(() => {
        handleOpenPop("pop-memo", _jsx(MemoPop, { engineerInfo: engineerInfo, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: t("라벨.반려") }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => ClosePop("pop-memo") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
        handleOpenPop("pop-cancel", _jsx(CancelPop, { engineerInfo: engineerInfo }));
        handleOpenPop("pop-delete", _jsx(DeletePop, { engineerInfo: engineerInfo }));
    }, [engineerInfo]);
    function ClosePop(id) {
        CUTIL.jsclose_Popup(id);
    }
    // 페이지
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    // 정렬
    const [sortData, setSortData] = useState({
        sortField: "",
        sort: "asc",
    });
    // 정렬 버튼 액션
    function onClickSort(sort) {
        // list 수정
        handleCurPage(0);
        const sortVal = {
            field: sort,
            data: sortData,
            setData: setSortData,
        };
        CUTIL.onClickSort(sortVal);
    }
    // 기본 주소
    let appPath = `?zoneId=${recoilTree.zone.zoneId}`;
    // 페이징 적용된 주소
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    if (sortData.sortField) {
        // 정렬 적용된 주소
        appPath = appPath + `&sort=${sortData.sortField},${sortData.sort}`;
    }
    // 사업장의 속한 사용자 목록 API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/zone/users${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setChnanTree(recoilTree);
                setUserList(data.body);
                // setEnginnerInfo(data.body[0])
                if (data.body.length > 0) {
                    setSelecteds(data.body[0].userTree.userTreeId);
                }
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
                if (chnanTree && chnanTree !== recoilTree) {
                    setSortData({
                        sortField: "",
                        sort: "asc",
                    });
                    handleCurPage(0);
                    /*    if (!isMobile) {
                      const selectId = document.getElementById("selects")
                      const selectId0 = document.getElementById("selects0")
                      selectId.click();
                      selectId0.click();
                      setSearchText("");
                      setSearchTextField({
                        searchField: searchFieldList[0].sfVal,
                        searchText: "",
                      });
                    } */
                }
                else {
                    // data.body.map((err) => (err.msg));
                }
            }
        }
    }, [data, reload, chnanTree, isMobile, langIds]);
    // 데이터 전달 및 팝업 열기
    function DeliveryDataPop(e, list) {
        setEngineerInfo(list);
        CUTIL.jsopen_Popup(e);
    }
    function onSelect(num) {
        setSelecteds(num);
    }
    return (_jsx(_Fragment, { children: userList && (_jsxs("div", Object.assign({ className: `box__body ${pageInfo.totalElements == 0 ? "nodata" : ""}`, style: { marginTop: isMobile ? "50px" : "24px" } }, { children: [_jsx("div", { className: "tbl__top" }), _jsx("p", Object.assign({ className: "nodata__txt" }, { children: t("라벨.조회된사용자목록이없습니다") })), _jsx("div", Object.assign({ className: "tbl-list tbl-select" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uC0AC\uC6A9\uC790 \uD0C0\uC785,\uC774\uB984,\uC18C\uC18D \uD68C\uC0AC,\uC5F0\uB77D\uCC98,\uB9C8\uC9C0\uB9C9 \uB85C\uADF8\uC778, \uC0AD\uC81C\uC694\uCCAD \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC0AC\uC6A9\uC790 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", Object.assign({ className: "sm-none" }, { children: [_jsx("col", { style: { width: "4%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "20%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "" } }), _jsx("col", { style: { width: "110px" } })] })), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "m-none w4p" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "role" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("role") }, { children: _jsx("span", { children: t("라벨.사용자타입") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "userName" && sortData.sort === "desc" ? "desc" : "asc"} `, onClick: (e) => onClickSort("userName") }, { children: _jsx("span", { children: t("라벨.이름") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "companyName" && sortData.sort === "desc" ? "desc" : "asc"}  m-none `, onClick: (e) => onClickSort("companyName") }, { children: _jsx("span", { children: t("라벨.소속회사") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "phoneNumber" && sortData.sort === "desc" ? "desc" : "asc"}  sm-none `, onClick: (e) => onClickSort("phoneNumber") }, { children: _jsx("span", { children: t("라벨.연락처") }) })), _jsx("th", Object.assign({ scope: "col", className: `sort ${sortData.sortField === "updatedTime" && sortData.sort === "desc" ? "desc" : "asc"}  m-none `, onClick: (e) => onClickSort("updatedTime") }, { children: _jsx("span", { children: t("라벨.마지막로그인") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C\uC694\uCCAD" })) }))] }) }), _jsx("tbody", { children: userList &&
                                    userList.map((list, idx) => (_jsxs("tr", Object.assign({ className: selecteds == list.userTree.userTreeId ? "selected" : "", onClick: (e) => onSelect(list.userTree.userTreeId) }, { children: [_jsx("td", Object.assign({ className: "m-none" }, { children: ++idx })), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.role ? list.role.substr(5) : "-" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.userName ? list.userName : "-" })) }), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.companyName ? list.companyName : "-" })) })), _jsx("td", Object.assign({ className: "sm-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.phoneNumber ? list.phoneNumber : "-" })) })), _jsx("td", Object.assign({ className: "m-none" }, { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.updatedTime ? CUTIL.utc2formedstr(list.updatedTime, "yyyy-MM-DD hh:mm:ss") : "-" })) })), _jsx("td", { children: list.role === "ROLE_ENGINEER" && list.userTree.approval == 2 ? (_jsx("button", Object.assign({ type: "button", className: ` js-open ${selecteds == list.userTree.userTreeId ? "btn-basic" : "btn-txt"}`, "data-pop": "pop-delete", onClick: (e) => DeliveryDataPop(e, list) }, { children: _jsx("span", { children: t("라벨.삭제요청") }) }))) : list.role === "ROLE_ENGINEER" && list.userTree.approval == 4 ? (_jsxs("button", Object.assign({ type: "button", className: "btn-small-round js-open", "data-pop": "pop-cancel", onClick: (e) => DeliveryDataPop(e, list) }, { children: [_jsx("span", { children: t("라벨.요청중") }), _jsx("span", { children: t("라벨.취소") })] }))) : list.role === "ROLE_ENGINEER" && list.userTree.approval == 5 ? (_jsxs("button", Object.assign({ type: "button", className: "btn-small-round red js-open", "data-pop": "pop-memo", onClick: (e) => DeliveryDataPop(e, list) }, { children: [_jsx("span", { children: t("라벨.반려") }), _jsx("span", { children: t("라벨.확인") })] }))) : ("") })] }), "userList" + idx.toString()))) })] })) })), _jsx(EhpPagination, { componentName: "USERS", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))) }));
}
export default UserList;
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
// 팝업
/* function SearchPop(props) {
  // props
  const { searchFieldList, searchText, setSearchText, setSearchTextField } = props;
  const [searchBoolean, setSearchBoolean] = useState(false);

  // 모바일 취소 이벤트 및 초기화
  function onClickCancel(e) {
    CUTIL.jsclose_Popup("pop-search-small");
    setSearchText("");
    setSearchTextField({
      searchField: searchFieldList[0].sfVal,
      searchText: "",
    });
    setSearchBoolean(true);
  }

  // 진입 시 초기화 이벤트
  useEffect(() => {
    setSearchBoolean(false);
  }, [searchBoolean]);

  // 엔터 검색
  function searchEnter(e) {
    if (e.key == "Enter") {
      handleGoSearch(e)
    }
  }

  function handleGoSearch(e) {
    const searchVal = {
      "id": "pop-search-small",
      "text": searchText,
      "setSearch": setSearchTextField
    }

    CUTIL.onClickSearch(searchVal);
    CUTIL.jsclose_Popup("pop-search-small");
  }

  return (
    <>
      <div className="popup__body">
        <div className="form__input mb-0">
          <div className="select" onClick={(e) => CUTIL.onClickSelect(e, CUTIL.selectOption)}>
            <div className="selected">
              <div className="selected-value" data-value={searchFieldList[0].sfVal}>{(!searchBoolean) ? searchFieldList[0].sfDisp : ""}</div>
              <div className="arrow"></div>
            </div>
            <ul>
              {searchFieldList.filter((sf) => (sf.sfVal !== "userName")).map((sf, idx) => (
                <li key={`sf_${idx.toString()}`} className="option" data-value={sf.sfVal}>{sf.sfDisp}</li>
              ))}
            </ul>
          </div>
          <input type="text" placeholder={t("라벨.텍스트입력")} value={searchText} onKeyDown={(e) => searchEnter(e)} onChange={(e) => setSearchText(e.target.value)} />
          {(searchText) &&
            <button type="button" className="btn btn-delete" onClick={(e) => setSearchText("")}><span className="hide">입력 창 닫기</span></button>
          }
        </div>
      </div>
      <div className="popup__footer">
        <button type="button" className="bg-gray js-close" onClick={(e) => onClickCancel(e)}><span>{t("라벨.취소")}</span></button>
        <button type="button" onClick={(e) => handleGoSearch(e)}><span>{t("라벨.검색")}</span></button>
      </div>
    </>
  );

}
 */
function DeletePop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    // props
    const { engineerInfo } = props;
    // 엔지니어 삭제요청 API
    function ApprovalDelete(e, engineerInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/usertree/${engineerInfo.userTree.userTreeId}/approval`,
                appQuery: {
                    approval: 4,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-delete");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("p", { children: t("라벨.등록된엔지니어를삭제요청하시겠습니까") }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-delete") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ApprovalDelete(e, engineerInfo) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function CancelPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    // props
    const { engineerInfo } = props;
    // 엔지니어 승인 API
    function ApprovalCancel(e, engineerInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/usertree/${engineerInfo.userTree.userTreeId}/approval`,
                appQuery: {
                    approval: 2,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    CUTIL.jsclose_Popup("pop-cancel");
                    setReload(false);
                }
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsxs("p", { children: [t("라벨.사업장에등록된엔지니어삭제"), " "] }) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-cancel") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ApprovalCancel(e, engineerInfo) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
function MemoPop(props) {
    const t = useTrans();
    // recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const setReload = useSetRecoilState(reLoad);
    const [checked, setChecked] = useState(true);
    function onChangeChecked(e) {
        if (checked) {
            setChecked(false);
        }
        else {
            setChecked(true);
        }
    }
    // props
    const { engineerInfo } = props;
    // 엔지니어 승인 API
    function ApprovalCancel(e, engineerInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            if (checked) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/product/usertree/${engineerInfo.userTree.userTreeId}/approval`,
                    appQuery: {
                        approval: 2,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        setReload(true);
                        setChecked(false);
                        CUTIL.jsclose_Popup("pop-memo");
                        setReload(false);
                    }
                }
            }
            else {
                setChecked(false);
                CUTIL.jsclose_Popup("pop-memo");
            }
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "popup__body" }, { children: _jsx("ul", Object.assign({ className: "form__input" }, { children: _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.반려사유") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsx("textarea", { className: "h142", readOnly: true, value: engineerInfo && engineerInfo.userTree.deniedReason ? engineerInfo.userTree.deniedReason : "" }), _jsxs("div", Object.assign({ className: "mt-8" }, { children: [_jsx("input", { type: "checkbox", id: "t_1", checked: checked ? true : false, onChange: (e) => onChangeChecked(e) }), _jsx("label", Object.assign({ htmlFor: "t_1", className: "w-auto" }, { children: t("라벨.엔지니어삭제요청을취소합니다") }))] }))] }))] }) })) })), _jsxs("div", Object.assign({ className: "popup__footer" }, { children: [_jsx("button", Object.assign({ type: "button", className: "bg-gray js-close", onClick: (e) => CUTIL.jsclose_Popup("pop-memo") }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", onClick: (e) => ApprovalCancel(e, engineerInfo) }, { children: _jsx("span", { children: t("라벨.확인") }) }))] }))] }));
}
